module.exports = __webpack_public_path__ + "img/female.3a8add7f.jpg";